module.exports = __webpack_public_path__ + "media/ding.aeaf6145.mp3";